import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../core'

export const RESOURCE = {
  payload: {
    description: 'A geographic location',
    name: 'Address',
    partialId: PartialId.Standard.create('address'),
  },
  type: core.quiver.Resource.Type.DmsStructure,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsStructure>
